export const dragIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7 2a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm6 0a2 2 0 0 0 0 4 2 2 0 0 0 0-4zM7 8a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm6 0a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm-6 6a2 2 0 0 0 0 4 2 2 0 0 0 0-4zm6 0a2 2 0 0 0 0 4 2 2 0 0 0 0-4z"/></svg>`,
  name: 'drag',
};
